export default {
  cover: {
    properties: {
      tealium_event: 'view',
      page: 'Selection',
      event_details: '',
      page_url: '/accreditation-tool/onboarding',
      event_category: '',
      event_subcategory: '',
      event_action: '',
      event_content: '',
      site_section: 'ib',
      page_language: 'en',
      page_type: 'application',
      page_customer_group: 'general',
      customer_group: 'general',
      page_business_line: '',
      page_security_level: '40',
      product_category: 'wealth management',
      product_subcategory: '',
      product_id: '',
      page_name: 'ib:accreditation tool:onboarding',
      page_category: 'accreditation tool',
      page_subcategory: 'onboarding',
      raw_datalayer: '5644v1',
      funnel_name: 'accredited investor onboarding',
      funnel_step: '',
      funnel_step_name: 'select',
      lead_event: '',
      application_event: '',
      site_country: 'australia',
      site_region: 'asia pacific',
    },
  },
  TermsAndConditions: {
    properties: {
      tealium_event: 'view',
      page: 'Terms and Conditions',
      event_details: '',
      page_url: '/accreditation-tool/terms-and-conditions',
      event_category: '',
      event_subcategory: '',
      event_action: '',
      event_content: '',
      site_section: 'ib',
      page_language: 'en',
      page_type: 'application',
      page_customer_group: 'general',
      customer_group: 'general',
      page_business_line: '',
      page_security_level: '40',
      product_category: 'wealth management',
      product_subcategory: '',
      product_id: '',
      page_name: 'ib:accreditation tool:terms and conditions',
      page_category: 'accreditation tool',
      page_subcategory: 'terms and conditions',
      raw_datalayer: '5644v7',
      funnel_name: 'accredited investor onboarding',
      funnel_step: '',
      funnel_step_name: 'terms and conditions',
      lead_event: '',
      application_event: '',
      site_country: 'australia',
      site_region: 'asia pacific',
    },
  },
  experience: {
    properties: {
      tealium_event: 'view',
      page: 'Accountant Certificate',
      event_details: '',
      page_url: '/accreditation-tool/accountant-certificate',
      event_category: '',
      event_subcategory: '',
      event_action: '',
      event_content: '',
      site_section: 'ib',
      page_language: 'en',
      page_type: 'application',
      page_customer_group: 'general',
      customer_group: 'general',
      page_business_line: '',
      page_security_level: '40',
      product_category: 'wealth management',
      product_subcategory: '',
      product_id: '',
      page_name: 'ib:accreditation tool:accountant certificate',
      page_category: 'accreditation tool',
      page_subcategory: 'accountant certificate',
      raw_datalayer: '5644v10',
      funnel_name: 'accredited investor onboarding - accountant certificate',
      funnel_step: '1',
      funnel_step_name: 'accountant certificate',
      lead_event: 'started',
      application_event: 'started',
      site_country: 'australia',
      site_region: 'asia pacific',
    },
  },
  experienceSubmit: {
    properties: {
      tealium_event: 'view',
      page: 'Accountant Certificate Submitted',
      event_details: '',
      page_url: '/accreditation-tool/accountant-certificate/submit',
      event_category: '',
      event_subcategory: '',
      event_action: '',
      event_content: '',
      site_section: 'ib',
      page_language: 'en',
      page_type: 'application',
      page_customer_group: 'general',
      customer_group: 'general',
      page_business_line: '',
      page_security_level: '40',
      product_category: 'wealth management',
      product_subcategory: '',
      product_id: '',
      page_name: 'ib:accreditation tool:accountant certificate:submit',
      page_category: 'accreditation tool',
      page_subcategory: 'accountant certificate',
      raw_datalayer: '5644v15',
      funnel_name: 'accredited investor onboarding - accountant certificate',
      funnel_step: '2',
      funnel_step_name: 'submit',
      lead_event: 'completed',
      application_event: 'submitted',
      site_country: 'australia',
      site_region: 'asia pacific',
    },
  },
  equities: {
    properties: {
      tealium_event: 'view',
      page: 'Questions Equities',
      event_details: '',
      page_url: '/accreditation-tool/knowledge-test/equities',
      event_category: '',
      event_subcategory: '',
      event_action: '',
      event_content: '',
      site_section: 'ib',
      page_language: 'en',
      page_type: 'application',
      page_customer_group: 'general',
      customer_group: 'general',
      page_business_line: '',
      page_security_level: '40',
      product_category: 'wealth management',
      product_subcategory: '',
      product_id: '',
      page_name: 'ib:accreditation tool:knowledge test:equities',
      page_category: 'accreditation tool',
      page_subcategory: 'knowledge test',
      raw_datalayer: '5644v17',
      funnel_name: 'accredited investor onboarding - knowledge test',
      funnel_step: '1',
      funnel_step_name: 'equities',
      lead_event: 'started',
      application_event: 'started',
      site_country: 'australia',
      site_region: 'asia pacific',
    },
  },
  fixedIncome: {
    properties: {
      tealium_event: 'view',
      page: 'Questions Fixed Income',
      event_details: '',
      page_url: '/accreditation-tool/knowledge-test/fixed-income',
      event_category: '',
      event_subcategory: '',
      event_action: '',
      event_content: '',
      site_section: 'ib',
      page_language: 'en',
      page_type: 'application',
      page_customer_group: 'general',
      customer_group: 'general',
      page_business_line: '',
      page_security_level: '40',
      product_category: 'wealth management',
      product_subcategory: '',
      product_id: '',
      page_name: 'ib:accreditation tool:knowledge test:fixed income',
      page_category: 'accreditation tool',
      page_subcategory: 'knowledge test',
      raw_datalayer: '5644v18',
      funnel_name: 'accredited investor onboarding - knowledge test',
      funnel_step: '2',
      funnel_step_name: 'fixed Income',
      lead_event: '',
      application_event: '',
      site_country: 'australia',
      site_region: 'asia pacific',
    },
  },
  managedFunds: {
    properties: {
      tealium_event: 'view',
      page: 'Questions Manage fund',
      event_details: '',
      page_url: '/accreditation-tool/knowledge-test/managed-fund',
      event_category: '',
      event_subcategory: '',
      event_action: '',
      event_content: '',
      site_section: 'ib',
      page_language: 'en',
      page_type: 'application',
      page_customer_group: 'general',
      customer_group: 'general',
      page_business_line: '',
      page_security_level: '40',
      product_category: 'wealth management',
      product_subcategory: '',
      product_id: '',
      page_name: 'ib:accreditation tool:knowledge test:managed fund',
      page_category: 'accreditation tool',
      page_subcategory: 'knowledge test',
      raw_datalayer: '5644v19',
      funnel_name: 'accredited investor onboarding - knowledge test',
      funnel_step: '3',
      funnel_step_name: 'managed fund',
      lead_event: '',
      application_event: '',
      site_country: 'australia',
      site_region: 'asia pacific',
    },
  },
  exchangeTradedFunds: {
    properties: {
      tealium_event: 'view',
      page: 'Question Exchange Traded',
      event_details: '',
      page_url: '/accreditation-tool/knowledge-test/exchange-traded',
      event_category: '',
      event_subcategory: '',
      event_action: '',
      event_content: '',
      site_section: 'ib',
      page_language: 'en',
      page_type: 'application',
      page_customer_group: 'general',
      customer_group: 'general',
      page_business_line: '',
      page_security_level: '40',
      product_category: 'wealth management',
      product_subcategory: '',
      product_id: '',
      page_name: 'ib:accreditation tool:knowledge test:exchange traded',
      page_category: 'accreditation tool',
      page_subcategory: 'knowledge test',
      raw_datalayer: '5644v19',
      funnel_name: 'accredited investor onboarding - knowledge test',
      funnel_step: '3',
      funnel_step_name: 'exchange traded',
      lead_event: '',
      application_event: '',
      site_country: 'australia',
      site_region: 'asia pacific',
    },
  },
  structuredProducts: {
    properties: {
      tealium_event: 'view',
      page: 'Questions Structured Products',
      event_details: '',
      page_url: '/accreditation-tool/knowledge-test/structured-product',
      event_category: '',
      event_subcategory: '',
      event_action: '',
      event_content: '',
      site_section: 'ib',
      page_language: 'en',
      page_type: 'application',
      page_customer_group: 'general',
      customer_group: 'general',
      page_business_line: '',
      page_security_level: '40',
      product_category: 'wealth management',
      product_subcategory: '',
      product_id: '',
      page_name: 'ib:accreditation tool:knowledge test:structured product',
      page_category: 'accreditation tool',
      page_subcategory: 'knowledge test',
      raw_datalayer: '5644v21',
      funnel_name: 'accredited investor onboarding - knowledge test',
      funnel_step: '5',
      funnel_step_name: 'structured products',
      lead_event: '',
      application_event: '',
      site_country: 'australia',
      site_region: 'asia pacific',
    },
  },
  progress: {
    properties: {
      tealium_event: 'view',
      page: 'Test Retrieve',
      event_details: '',
      page_url: '/accreditation-tool/knowledge-test/test-retrieve',
      event_category: '',
      event_subcategory: '',
      event_action: '',
      event_content: '',
      site_section: 'ib',
      page_language: 'en',
      page_type: 'application',
      page_customer_group: 'general',
      customer_group: 'general',
      page_business_line: '',
      page_security_level: '40',
      product_category: 'wealth management',
      product_subcategory: '',
      product_id: '',
      page_name: 'ib:accreditation tool:knowledge test:test retrieve',
      page_category: 'accreditation tool',
      page_subcategory: 'knowledge test',
      raw_datalayer: '5644v25',
      funnel_name: 'accredited investor onboarding - knowledge test',
      funnel_step: '9',
      funnel_step_name: 'test retrieve',
      lead_event: '',
      application_event: '',
      site_country: 'australia',
      site_region: 'asia pacific',
    },
  },
  failed: {
    properties: {
      tealium_event: 'view',
      page: 'Test Fail',
      event_details: '',
      page_url: '/accreditation-tool/knowledge-test/test-failed',
      event_category: '',
      event_subcategory: '',
      event_action: '',
      event_content: '',
      site_section: 'ib',
      page_language: 'en',
      page_type: 'application',
      page_customer_group: 'general',
      customer_group: 'general',
      page_business_line: '',
      page_security_level: '40',
      product_category: 'wealth management',
      product_subcategory: '',
      product_id: '',
      page_name: 'ib:accreditation tool:knowledge test:test failed',
      page_category: 'accreditation tool',
      page_subcategory: 'knowledge test',
      raw_datalayer: '5644v27',
      funnel_name: 'accredited investor onboarding - knowledge test',
      funnel_step: '9',
      funnel_step_name: 'test failed',
      lead_event: '',
      application_event: '',
      site_country: 'australia',
      site_region: 'asia pacific',
    },
  },
  passed: {
    properties: {
      tealium_event: 'view',
      page: 'Test Pass',
      event_details: '',
      page_url: '/accreditation-tool/knowledge-test/test-pass',
      event_category: '',
      event_subcategory: '',
      event_action: '',
      event_content: '',
      site_section: 'ib',
      page_language: 'en',
      page_type: 'application',
      page_customer_group: 'general',
      customer_group: 'general',
      page_business_line: '',
      page_security_level: '40',
      product_category: 'wealth management',
      product_subcategory: '',
      product_id: '',
      page_name: 'ib:accreditation tool:knowledge test:test pass',
      page_category: 'accreditation tool',
      page_subcategory: 'knowledge test',
      raw_datalayer: '5644v29',
      funnel_name: 'accredited investor onboarding - knowledge test',
      funnel_step: '10',
      funnel_step_name: 'test pass',
      lead_event: '',
      application_event: '',
      site_country: 'australia',
      site_region: 'asia pacific',
    },
  },
};
